<template>
    <div class="inner-wrapper">
   <div class="page-title" style="width:100%">
      <!--<h1 class="float-left">Tasks</h1>-->
      <div class="title-right float-right">
        <div class="btnrow float-right">
                        <a href="javascript:void(0)" @click="addVendorBag()" class="btn create-btn">
                            <!--<i class="fa fa-plus" aria-hidden="true"></i>--><i  class="ri-add-circle-line align-bottom me-1"></i> Add Task
                            </a>
                        </div>
      </div>
   </div>
      <div class="new-rfq">



        <div class="row">

            <div class="col-lg-12 col-md-12">
                <div class="card panel ">
                    <div class="card-header headnbtn">
                        <div  class="d-flex align-items-center justify-content-between">
                        <h5  class="card-title mb-0 flex-grow-1">List of Task</h5>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive product-create mb-0">
                            <table class="table table-custom table-nowrap table-bordered align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Task Name</th>
                                    <th>Assigned to</th>
                                    <th> Due Date</th>
                                    <th style="width: 80px">Action </th>
                                </tr>
                            </thead>
                            <template v-for="(task, index) in taskData.quotations_tasks.data">
                                <tr :id="task.id">
                                    <td class="t-sts">
                                        <i v-if="task.task_status !='1'" class="fa fa-check-circle "id="t-crc" ></i>
                                        <i v-else class="fa fa-check-circle" style="color: green;" id="t-crc" ></i>
                                        {{task.title}}
                                    </td>
                                    <td v-if="task.user_type !='admin'">{{taskData.names[task.id]}}</td>
                                    <td v-else>{{getAuthUser.name}}</td>

                                    <td><template v-if="task.due_date">{{formatDate(task.due_date)}}</template></td>
                                    <td> <router-link
                                                 :to="{name: 'taskView', params: {id: task.id}}"
                                                 class="btn view-btn" title="Details Task" :data-id="task.id">
                                                 <i class="ri-eye-line"></i></router-link>

                                    <router-link
                                    :to="{name: 'taskEdit', params: {id: task.id}}"
                                    class="edit_btn" title="Edit Task" :data-id="task.id">
                                        <i class="ri-edit-fill me-1"></i></router-link>
                                    </td>
                                </tr>
                            </template>
                            </table>
                        </div>

                    </div>

                    <div class="btnrow text-left mb-3">
                        <template>
                        <div class="overflow-auto">
                            <b-pagination
                            v-model="current_page"
                            :total-rows="total"
                            :per-page="per_page"
                            ></b-pagination>

                            <!-- <p class="mt-3">Current Page: {{ current_page }}</p> -->


                        </div>
                        </template>
                    </div>
                </div>


            </div>
        </div>


            
      </div>

<!-- Add Modal -->
<div id="createVendor" class="modal fade">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
            <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                <strong class="success_msg">{{successMessage}}</strong>
            </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form  @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">

                <div class="modal-header  bg-soft-info">

                    <h5 class="modal-title">Add Task</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">
                   <div class="form-group">
                    <validation-provider rules="required" v-slot="{ errors }">
                        <label for="name">Task Name:</label>
                        <input type="text" class="form-control" id="name" v-model="form.title" >
                        <span class="error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    <div class="form-group">
                        <label for="pwd">Assigned to:</label>
                        <validation-provider rules="required" v-slot="{ errors }">
                            <v-select label="name" v-model="form.assign_to" :filterable="false" :options="options" :reduce="(option) => option.id" @search="onSearch">
                                    <template slot="no-options">
                                    Search User
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.name }}
                                    </div>
                                    </template>
                                </v-select>
                            <span class="error">{{ errors[0] }}</span>
                        </validation-provider>
                    </div>
                    <div class="form-group">
                        <label for="pwd">Due Date:</label><br>
                        <template>
                        <validation-provider rules="required" v-slot="{ errors }">
                            <date-range-picker :ranges=false :autoApply="autoApply"  :showDropdowns="showDropdowns" v-model="dateRange" :singleDatePicker="singleDatePicker" @update="updateValues">
                            </date-range-picker>
                        <span class="error">{{ errors[0] }}</span>
                        </validation-provider>
                        </template>
                    </div>

                    <input type="hidden" name="delete_id" id="delete_id" value="">
                    <div class="btnrow text-right">
                        <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                        <button type="submit" :disabled="buttonDisable" class="btn btn-primary">Save</button>
                    </div>
                </div>
                
            </form>
            </ValidationObserver>
            </div>
        </div>
    </div>
<!-- Add Modal Ends Here -->
      <!-- Delete Modal HTML -->
    <div id="deleteModal" class="modal fade">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
                <div class="modal-header bg-soft-info">
                    <div class="icon-box">
                        <i class="fas fa-close"></i>
                    </div>
                    <h4 class="modal-title">Are you sure?</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">
                    <p>Do you really want to delete these records? This process cannot be undone.</p>
                </div>
                <input type="hidden" name="delete_id" id="delete_id" value="">
                <div class="modal-footer">
                    <button type="button" class="btn btn-info" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger confirm_delete" @click="deleteCustomer()">Delete</button>
                </div>
            </div>
        </div>
    </div>

   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import moment from 'moment';
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  });
}
export default {
    name: "TaskList",
    components: {
        ValidationProvider,ValidationObserver
    },
    created() {
        this.getTasks();
    },
    data(){
        return {
            buttonDisable:false,
            selected:[],
            options:[],
            inlineDatePicker:true,
            autoApply:false,
            singleDatePicker:true,
            showDropdowns:true,
            current_page:1,
            per_page:10,
            total:0,
            inlineDateRange:{
                startDate: moment().subtract(29, 'days').toDate(),
                endDate: moment().toDate(),
                ranges: false
            },
            dateRange: {
               startDate: moment().subtract(29, 'days').toDate(),
               endDate: moment().toDate(),
               //ranges:false
            },
            taskData: {
                tasks: null,
                config: null,
                can_add_task: false,
                can_edit_task: false,
                can_delete_task: false,
                user_type: null,
                role: null,
                data: null,
                notify: null,
                DesktopNotification: null,
                names: [],
                quotations_tasks: []
            },
            filterForm: {
                search_filter: null,
                status_filter: null
            },
            form:{
                title:null,
                assign_to:null,
                due_date:null,
                customer_id:null,
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setCustomerLoading'
        ]),
        addVendorBag(){
            $('#createVendor').modal('show');
        },
        updateValues(){
            console.log("Start DAte",moment(this.dateRange.startDate).format('YYYY-MM-DD'));
            console.log("Start endDate",moment(this.dateRange.endDate).format('YYYY-MM-DD'));
            this.form.due_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        },

        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('tasks.search',{search: search} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    let customer = [];
                    let allData =  data.data.data
                    console.log("Length",allData,allData.length);
                    vm.options = data.data.data;

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },

        getTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('tasks.index'), {
                params: this.filterForm,
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.taskData = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.taskData.config['start_from']) + index;
        },
        showDelete(id) {
            this.deleteId = id;
            //$('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        save(){
            this.buttonDisable = true;
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('tasks.store'), this.form,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    this.buttonDisable = false;
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.reset();
                        self.setSuccessMessage(data.message);
                       $('#createVendor').modal('hide');
                       self.setSuccessMessage(null);
                       this.getTasks();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    this.buttonDisable = false;
                    self.setCustomerLoading(false);

                });
        },
        async reset() {
            this.form = {
                        product_name: null,
                        price: null,
                        product_desc: null,
                        price: null,
                        product_num: null,
                        vendor_id: null,
                        selling: null,
            }
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        deleteTask() {
            if(this.deleteId) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('tasks.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.deleteId = null;
                            self.getTasks();
                            $('#deleteModal').modal('hide');
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>
